/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Example_CaptionInputs */

const en_gc_search_guides_what_is_gridcraft_sections_5_example_caption = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Example_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the value or formula after each cell address. This example is intentionally small enough to verify by hand.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_5_example_caption = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Example_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在对应单元格输入地址后面的值或公式。这个例子刻意保持较小规模，方便手算验证。`)
};

/**
* | output |
* | --- |
* | "Enter the value or formula after each cell address. This example is intentionally small enough to verify by hand." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Example_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_5_example_caption = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Example_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_5_Example_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_5_example_caption(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_5_example_caption(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_5_example_caption as "gc.search_guides.what_is_gridcraft.sections.5.example.caption" }